module.exports = __webpack_public_path__ + "static/media/climbing2.0dcad651.jpg";